import { createRoot } from 'react-dom/client'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

// Local imports
import App from './App'
import { store, persistor } from "./store";

// Assets
import './styles/styles.global.scss'

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store} >
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
                <App tab="home" />
            </BrowserRouter>
        </PersistGate>
    </Provider >
);